import { defineComponent, watchEffect } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiTabBar",
  props: {
    tabs: { type: Array, required: true },
    value: { type: null, required: true }
  },
  emits: ["input"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const isTabActive = (tab) => {
      var _a;
      return ((_a = props.value) == null ? void 0 : _a.key) === tab.key;
    };
    const isTabDisabled = (tab) => {
      var _a;
      return (_a = tab.disabled) != null ? _a : false;
    };
    const changeTab = (tab) => {
      if (isTabDisabled(tab)) {
        return;
      }
      emits("input", tab);
    };
    watchEffect(() => {
      if (props.tabs.length > 0 && !props.value) {
        changeTab(props.tabs[0]);
      }
    });
    return { __sfc: true, props, emits, isTabActive, isTabDisabled, changeTab };
  }
});

export { _sfc_main as default };
